export const clStyles = `
.cl-page { min-height: 100vh; background: #0a0a0f; color: #e5e5e5; padding: 24px 16px; }
.cl-container { max-width: 840px; margin: 0 auto; }
.cl-page-header { display: flex; align-items: center; gap: 16px; margin-bottom: 24px; }
.cl-page-icon { width: 48px; height: 48px; border-radius: 14px; background: rgba(59,130,246,0.1); border: 1px solid rgba(59,130,246,0.2); display: flex; align-items: center; justify-content: center; color: #60a5fa; flex-shrink: 0; }
.cl-page-title { font-size: 22px; font-weight: 700; color: #fafafa; margin: 0; letter-spacing: -0.02em; }
.cl-page-sub { font-size: 13px; color: #737373; margin: 4px 0 0; }

/* List */
.cl-list-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.cl-list-title { font-size: 16px; font-weight: 700; color: #fafafa; margin: 0; }
.cl-list-sub { font-size: 12px; color: #737373; margin: 2px 0 0; }
.cl-filters { display: flex; gap: 6px; margin-bottom: 16px; flex-wrap: wrap; }
.cl-filter-btn { padding: 5px 14px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06); background: rgba(255,255,255,0.02); color: #a3a3a3; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.cl-filter-btn:hover { background: rgba(255,255,255,0.05); }
.cl-filter-btn.active { background: rgba(59,130,246,0.12); border-color: rgba(59,130,246,0.3); color: #60a5fa; }
.cl-case-cards { display: flex; flex-direction: column; gap: 10px; }
.cl-case-card { text-align: left; padding: 16px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.06); background: rgba(255,255,255,0.02); cursor: pointer; transition: all 0.15s; width: 100%; }
.cl-case-card:hover { background: rgba(255,255,255,0.04); border-color: rgba(59,130,246,0.2); }

/* ── P85 Modern Case Cards ─────────────────────────────────────────── */
.cl-case-card--modern {
  background: linear-gradient(180deg, rgba(255,255,255,0.025) 0%, rgba(255,255,255,0.005) 100%);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 16px;
  padding: 16px 16px 14px;
  transition: border-color 220ms cubic-bezier(0.16,1,0.3,1), transform 220ms cubic-bezier(0.16,1,0.3,1), box-shadow 220ms;
}
.cl-case-card--modern:hover {
  border-color: rgba(34,211,238,0.35);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4), 0 0 0 1px rgba(34,211,238,0.18);
}
.cl-case-card--stale {
  border-left: 3px solid rgba(251,146,60,0.7);
}
.cl-card-stats {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px dashed rgba(255,255,255,0.06);
}
.cl-stat { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.cl-stat-label {
  font-size: 9.5px; font-weight: 700; letter-spacing: 0.12em;
  color: #64748b; text-transform: uppercase;
}
.cl-stat-value {
  font-size: 12.5px; font-weight: 700; color: #f1f5f9;
  font-variant-numeric: tabular-nums;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.cl-stat-value--warn { color: #fb923c; }
.cl-stat-value--action {
  color: #22d3ee;
  text-transform: none;
}
.cl-stat--action {
  text-align: right;
}
@media (min-width: 600px) {
  .cl-case-cards { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
}
.cl-card-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.cl-card-id { font-size: 11px; font-weight: 700; color: #525252; letter-spacing: 0.06em; font-family: monospace; }
.cl-card-title { font-size: 15px; font-weight: 600; color: #fafafa; margin: 0 0 6px; }
.cl-card-meta { display: flex; gap: 10px; font-size: 11px; color: #737373; margin-bottom: 6px; }
.cl-card-summary { font-size: 13px; color: #a3a3a3; line-height: 1.5; margin: 0 0 8px; }
.cl-card-footer { display: flex; gap: 14px; font-size: 11px; color: #525252; }
.cl-card-footer span { display: flex; align-items: center; gap: 4px; }

/* Status */
.cl-status-badge { display: inline-flex; padding: 3px 10px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid; letter-spacing: 0.04em; text-transform: uppercase; }
.cl-issue-label { font-size: 11px; color: #737373; }

/* Form */
.cl-form { background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 14px; padding: 24px; }
.cl-form-title { font-size: 18px; font-weight: 700; color: #fafafa; margin: 0 0 20px; }
.cl-label { display: block; font-size: 12px; font-weight: 600; color: #a3a3a3; margin-bottom: 14px; }
.cl-input { display: block; width: 100%; margin-top: 6px; padding: 9px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.03); color: #e5e5e5; font-size: 14px; outline: none; box-sizing: border-box; }
.cl-input:focus { border-color: rgba(59,130,246,0.4); }
.cl-select { display: block; width: 100%; margin-top: 6px; padding: 9px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08); background: rgba(0,0,0,0.3); color: #e5e5e5; font-size: 14px; }
.cl-textarea { display: block; width: 100%; margin-top: 6px; padding: 9px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.03); color: #e5e5e5; font-size: 14px; resize: vertical; font-family: inherit; box-sizing: border-box; }
.cl-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.cl-inline-add { display: flex; gap: 8px; margin-top: 6px; align-items: center; }
.cl-inline-add .cl-input { flex: 1; margin-top: 0; }
.cl-tag { display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; border-radius: 6px; background: rgba(59,130,246,0.08); border: 1px solid rgba(59,130,246,0.2); color: #93c5fd; font-size: 12px; margin: 4px 4px 0 0; }
.cl-tag button { background: none; border: none; color: #93c5fd; cursor: pointer; padding: 0; display: flex; }
.cl-form-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; }

/* Buttons */
.cl-btn-primary { display: flex; align-items: center; gap: 8px; padding: 9px 18px; border: none; border-radius: 10px; background: #2563eb; color: white; font-weight: 600; font-size: 13px; cursor: pointer; transition: opacity 0.15s; }
.cl-btn-primary:hover { opacity: 0.9; }
.cl-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
.cl-btn-secondary { padding: 9px 18px; border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; background: transparent; color: #a3a3a3; font-weight: 600; font-size: 13px; cursor: pointer; }
.cl-btn-sm { display: flex; align-items: center; gap: 6px; padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.03); color: #a3a3a3; font-size: 12px; font-weight: 600; cursor: pointer; }
.cl-btn-sm:hover { background: rgba(255,255,255,0.06); }
.cl-btn-sm:disabled { opacity: 0.4; }
.cl-btn-back { display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06); background: transparent; color: #737373; font-size: 12px; font-weight: 600; cursor: pointer; margin-bottom: 16px; }

/* Detail */
.cl-detail-header { display: flex; justify-content: space-between; align-items: flex-start; padding: 20px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 14px; margin-bottom: 16px; }
.cl-detail-id { font-size: 11px; font-weight: 700; color: #525252; font-family: monospace; letter-spacing: 0.06em; }
.cl-detail-title { font-size: 20px; font-weight: 700; color: #fafafa; margin: 4px 0 8px; }
.cl-detail-meta { display: flex; gap: 12px; font-size: 12px; color: #737373; flex-wrap: wrap; }
.cl-detail-header-right { display: flex; gap: 8px; align-items: flex-start; flex-shrink: 0; }

/* Status dropdown */
.cl-status-dropdown { position: relative; }
.cl-status-trigger { display: flex; align-items: center; gap: 6px; background: none; border: 1px solid rgba(255,255,255,0.08); border-radius: 8px; padding: 6px 10px; cursor: pointer; color: #a3a3a3; }
.cl-status-menu { position: absolute; right: 0; top: 100%; margin-top: 4px; background: #1a1a2e; border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; padding: 6px; z-index: 20; min-width: 180px; }
.cl-status-option { display: flex; align-items: center; gap: 8px; width: 100%; padding: 8px 12px; border: none; background: transparent; color: #d4d4d4; font-size: 13px; cursor: pointer; border-radius: 6px; text-align: left; }
.cl-status-option:hover { background: rgba(255,255,255,0.05); }
.cl-status-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

/* Sections */
.cl-section { padding: 16px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 12px; margin-bottom: 12px; }
.cl-section-title { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 700; color: #a3a3a3; text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 10px; }
.cl-section-body { font-size: 14px; color: #d4d4d4; line-height: 1.7; margin: 0; }
.cl-section-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.cl-section-half { flex: 1; }
@media (max-width: 640px) { .cl-section-row { grid-template-columns: 1fr; } }

/* P76: Step 2 Grievance Book Checklist */
.cl-step2 { padding: 0; overflow: hidden; }
.cl-step2-head {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 14px 16px; background: transparent; border: 0; cursor: pointer;
  text-align: left;
}
.cl-step2-head:hover { background: rgba(56,189,248,0.04); }
.cl-step2-head svg { color: #7dd3fc; flex-shrink: 0; }
.cl-step2-title { font-size: 12px; font-weight: 800; letter-spacing: 0.06em;
  text-transform: uppercase; color: #bae6fd; }
.cl-step2-count { margin-left: 6px; padding: 2px 9px; border-radius: 99px;
  background: rgba(56,189,248,0.16); color: #e0f2fe;
  font-size: 11px; font-weight: 800; font-variant-numeric: tabular-nums; }
.cl-step2-ready { margin-left: auto; padding: 2px 9px; border-radius: 99px;
  background: rgba(34,197,94,0.20); color: #86efac;
  font-size: 10px; font-weight: 800; letter-spacing: 0.08em; }
.cl-step2-bar-track { position: relative; height: 8px; background: rgba(255,255,255,0.05);
  margin: 0 16px 12px; border-radius: 99px; overflow: hidden; }
.cl-step2-bar-fill { position: absolute; top: 0; left: 0; height: 100%;
  border-radius: 99px; transition: width 250ms ease; }
.cl-step2-bar-label { position: absolute; right: 0; top: -16px; font-size: 10px;
  font-weight: 700; color: #a1a1aa; letter-spacing: 0.04em; }
.cl-step2-list { list-style: none; margin: 0; padding: 0 8px 12px;
  display: flex; flex-direction: column; gap: 4px; }
.cl-step2-row { display: flex; align-items: flex-start; gap: 10px;
  padding: 8px 10px; border-radius: 8px;
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.04); }
.cl-step2-row-done { background: rgba(34,197,94,0.06);
  border-color: rgba(34,197,94,0.18); }
.cl-step2-check { flex-shrink: 0; background: transparent; border: 0;
  padding: 2px; cursor: pointer; }
.cl-step2-check:disabled { opacity: 0.4; cursor: not-allowed; }
.cl-step2-check-on { color: #22c55e; }
.cl-step2-check-off { color: #64748b; }
.cl-step2-content { flex: 1; min-width: 0; }
.cl-step2-label { font-size: 13px; font-weight: 700; color: #fafafa;
  line-height: 1.35; }
.cl-step2-row-done .cl-step2-label { color: #d4d4d4; }
.cl-step2-evidence { font-size: 11.5px; color: #94a3b8; margin-top: 2px;
  line-height: 1.4; }

/* P78: Grievance Documentation Pack */
.cl-gdoc { padding: 0; overflow: hidden; }
.cl-gdoc-body { padding: 0 16px 14px; display: flex; flex-direction: column; gap: 12px; }
.cl-gdoc-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
@media (max-width: 720px) { .cl-gdoc-grid { grid-template-columns: 1fr; } }
.cl-gdoc-field { display: flex; flex-direction: column; gap: 4px; }
.cl-gdoc-field-full { grid-column: 1 / -1; }
.cl-gdoc-label { font-size: 10px; font-weight: 800; letter-spacing: 0.08em;
  color: #94a3b8; text-transform: uppercase; }
.cl-gdoc-input, .cl-gdoc-textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.30);
  color: #fafafa;
  font-size: 12.5px; font-family: inherit; line-height: 1.5;
  box-sizing: border-box;
}
.cl-gdoc-textarea { resize: vertical; }
.cl-gdoc-input:focus, .cl-gdoc-textarea:focus {
  outline: 0; border-color: rgba(125, 211, 252, 0.45);
}
.cl-gdoc-actions {
  display: flex; gap: 8px; justify-content: flex-end; padding-top: 4px;
}
.cl-gdoc-save, .cl-gdoc-export {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; border-radius: 8px; border: 1px solid;
  font-size: 11.5px; font-weight: 700; letter-spacing: 0.04em;
  cursor: pointer;
}
.cl-gdoc-save {
  border-color: rgba(56, 189, 248, 0.45);
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.22), rgba(56, 189, 248, 0.10));
  color: #e0f2fe;
}
.cl-gdoc-save:hover { background: linear-gradient(135deg, rgba(56, 189, 248, 0.32), rgba(56, 189, 248, 0.16)); }
.cl-gdoc-save:disabled { opacity: 0.5; cursor: not-allowed; }
.cl-gdoc-export {
  border-color: rgba(251, 191, 36, 0.45);
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.22), rgba(217, 119, 6, 0.16));
  color: #fef3c7;
}
.cl-gdoc-export:hover { background: linear-gradient(135deg, rgba(245, 158, 11, 0.32), rgba(217, 119, 6, 0.22)); }

/* Spec Timeline table */
.cl-spec-table {
  display: flex; flex-direction: column; gap: 4px;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 8px; padding: 6px;
  background: rgba(0,0,0,0.18);
}
.cl-spec-row {
  display: grid;
  grid-template-columns: 90px 1fr 1fr 1fr 32px;
  gap: 8px;
  padding: 6px 8px;
  font-size: 12px; color: #e5e7eb; line-height: 1.45;
  border-radius: 6px;
}
.cl-spec-row:nth-child(odd) { background: rgba(255,255,255,0.02); }
.cl-spec-row-head {
  font-size: 9px; font-weight: 800; letter-spacing: 0.10em;
  color: #94a3b8; padding-top: 4px; padding-bottom: 4px;
}
.cl-spec-del {
  background: transparent; border: 0; padding: 4px;
  color: #f87171; cursor: pointer; border-radius: 4px;
}
.cl-spec-del:hover { background: rgba(248,113,113,0.10); }
.cl-spec-del:disabled { opacity: 0.4; cursor: not-allowed; }
@media (max-width: 720px) {
  .cl-spec-row { grid-template-columns: 1fr; }
  .cl-spec-row-head { display: none; }
}
.cl-spec-add { margin-top: 6px; }
.cl-spec-add-grid {
  display: grid;
  grid-template-columns: 130px 1fr 1fr 1fr;
  gap: 8px;
}
@media (max-width: 720px) { .cl-spec-add-grid { grid-template-columns: 1fr; } }

/* People */
.cl-person { padding: 6px 0; border-bottom: 1px solid rgba(255,255,255,0.04); }
.cl-person:last-child { border-bottom: none; }
.cl-person-name { font-size: 13px; font-weight: 600; color: #fafafa; }
.cl-person-role { font-size: 11px; color: #737373; margin-left: 8px; }
.cl-person-notes { display: block; font-size: 12px; color: #525252; margin-top: 2px; }
.cl-witness { font-size: 13px; color: #d4d4d4; padding: 4px 0; }

/* Attachments */
.cl-attachment { display: flex; align-items: center; gap: 8px; padding: 6px 0; font-size: 13px; color: #d4d4d4; }
.cl-att-type { font-size: 11px; color: #525252; }
.cl-upload-btn { display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px; border-radius: 8px; border: 1px dashed rgba(255,255,255,0.12); color: #737373; font-size: 12px; cursor: pointer; margin-top: 8px; }
.cl-upload-btn:hover { border-color: rgba(59,130,246,0.3); color: #93c5fd; }

/* Linked */
.cl-linked-item { display: flex; align-items: center; gap: 8px; padding: 8px 0; font-size: 13px; color: #d4d4d4; border-bottom: 1px solid rgba(255,255,255,0.04); }
.cl-linked-item:last-child { border-bottom: none; }

/* Timeline */
.cl-add-note { display: flex; gap: 8px; margin-bottom: 14px; }
.cl-add-note .cl-input { margin: 0; flex: 1; }
.cl-timeline { position: relative; padding-left: 20px; }
.cl-tl-entry { position: relative; padding-bottom: 14px; }
.cl-tl-dot { position: absolute; left: -24px; top: 4px; width: 8px; height: 8px; border-radius: 50%; background: rgba(59,130,246,0.4); border: 2px solid #0a0a0f; }
.cl-tl-entry::before { content: ''; position: absolute; left: -21px; top: 14px; bottom: 0; width: 1px; background: rgba(255,255,255,0.06); }
.cl-tl-entry:last-child::before { display: none; }
.cl-tl-content { padding-left: 4px; }
.cl-tl-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px; }
.cl-tl-action { font-size: 11px; font-weight: 700; color: #60a5fa; text-transform: uppercase; letter-spacing: 0.04em; }
.cl-tl-time { font-size: 11px; color: #525252; }
.cl-tl-desc { font-size: 13px; color: #d4d4d4; margin: 0; line-height: 1.5; }
.cl-tl-actor { font-size: 11px; color: #525252; }
.cl-tl-source { font-size: 10px; color: #525252; margin-left: 6px; font-family: monospace; }

/* Empty / Loading */
.cl-empty { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 48px 24px; color: #525252; text-align: center; }
.cl-empty-text { font-size: 13px; color: #525252; margin: 0; }
.cl-loading { padding: 32px; text-align: center; color: #525252; font-size: 14px; }

/* Search + issue filter row */
.cl-search-row { display: flex; gap: 8px; margin-bottom: 10px; align-items: center; flex-wrap: wrap; }
.cl-search-wrap { position: relative; flex: 1 1 240px; display: flex; align-items: center; gap: 6px; padding: 0 10px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.03); }
.cl-search-wrap svg { color: #737373; flex-shrink: 0; }
.cl-search-input { flex: 1; background: transparent; border: none; outline: none; padding: 8px 0; font-size: 13px; color: #e5e5e5; font-family: inherit; }
.cl-search-input::placeholder { color: #525252; }
.cl-search-clear { background: none; border: none; color: #737373; cursor: pointer; padding: 4px; display: flex; }
.cl-search-clear:hover { color: #d4d4d4; }
.cl-issue-filter { width: 200px; margin: 0; }

/* Edit mode inputs in header */
.cl-edit-title { font-size: 18px; font-weight: 700; margin-top: 6px; }
.cl-edit-inline { margin: 0; width: auto; font-size: 12px; padding: 5px 10px; }

/* Drag-drop zone */
.cl-dropzone {
  display: flex; align-items: center; gap: 14px;
  padding: 18px 20px; margin-top: 12px;
  border: 2px dashed rgba(255,255,255,0.12);
  border-radius: 12px;
  background: rgba(255,255,255,0.02);
  color: #a3a3a3;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.cl-dropzone:hover, .cl-dropzone:focus-visible { border-color: rgba(59,130,246,0.4); color: #d4d4d4; }
.cl-dropzone-active {
  border-color: rgba(59,130,246,0.7) !important;
  background: rgba(59,130,246,0.07) !important;
  color: #dbeafe !important;
}
.cl-dropzone svg { flex-shrink: 0; }
.cl-dropzone-title { font-size: 13px; font-weight: 600; color: inherit; }
.cl-dropzone-hint { font-size: 11px; color: #737373; margin-top: 2px; }
.cl-upload-error {
  display: flex; align-items: center; gap: 6px;
  margin-top: 8px; padding: 6px 10px;
  border-radius: 6px;
  background: rgba(239,68,68,0.08);
  border: 1px solid rgba(239,68,68,0.25);
  color: #fca5a5; font-size: 12px; font-weight: 600;
}
.cl-upload-error svg { flex-shrink: 0; }

/* Attachment cards (grid with image thumbs / PDF icons) */
.cl-attachment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  margin-bottom: 4px;
}
.cl-att-card {
  display: flex; flex-direction: column;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.03);
  overflow: hidden;
}
.cl-att-thumb {
  display: flex; align-items: center; justify-content: center;
  width: 100%; aspect-ratio: 4 / 3;
  border: none; cursor: pointer;
  background: rgba(0,0,0,0.25);
  color: #93c5fd;
  transition: background 0.15s;
}
.cl-att-thumb:hover { background: rgba(59,130,246,0.1); }
.cl-att-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.cl-att-info { padding: 8px 10px; display: flex; flex-direction: column; gap: 4px; }
.cl-att-name {
  font-size: 12px; font-weight: 600; color: #e5e5e5;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.cl-att-meta {
  display: flex; justify-content: space-between; align-items: center;
  font-size: 10px; color: #737373;
}
.cl-att-download {
  display: inline-flex; align-items: center; gap: 4px;
  background: none; border: none;
  color: #93c5fd; font-size: 10px; font-weight: 600;
  cursor: pointer; padding: 2px 6px; border-radius: 4px;
  font-family: inherit;
}
.cl-att-download:hover { background: rgba(59,130,246,0.1); }
`;
